import type { User } from '@/features/portfolio/types/user';

export const USER = {
  firstName: 'Victor',
  lastName: 'Saisse',
  displayName: 'Victor Saisse',
  username: 'victorsaisse',
  gender: undefined,
  pronouns: undefined,
  bio: "Being a 10x developer doesn't mean you ship 10x more; it means you deliver 10x more value. That's the bar I build against: nine years shipping web, mobile, and AI products with React Native, Next.js, TypeScript, and Cloudflare, now Founding Engineer at LA Viral Studio in Montréal.",
  flipSentences: [
    '10x value, not 10x output',
    'Founding Engineer @ LA Viral Studio',
    'Founder mindset, engineer hands',
    'Training for a marathon, Oct 2026',
  ],
  address: 'Montréal, Québec, Canada',
  phoneNumber: undefined, // E.164 format, base64 encoded when set
  email: 'c2Fpc3NldmljdG9yQGdtYWlsLmNvbQ==', // base64 encoded
  website: 'https://www.victorsaisse.com',
  jobTitle: 'Founding Engineer',
  jobs: [
    {
      title: 'Founding Engineer',
      company: 'LA Viral Studio',
      website: 'https://www.linkedin.com/company/la-viral-studio',
    },
  ],
  about: `Hey, I'm Victor 👋

Founding Engineer at [LA Viral Studio](https://www.linkedin.com/company/la-viral-studio), building mobile (React Native + Expo), web (Next.js), and edge infra (Cloudflare Workers, Supabase) alongside the founders, on products reaching millions of users. Lately, that mostly means working hard with great people and trying to scale a startup.

**How I got here.** I started in 2017 fixing lab computers at a technical school in Rio de Janeiro. Then WordPress and PHP for client sites. Then React and Node. Each year the tools got better and so did the problems: leading a small team through an e-commerce overhaul, founding my own product and learning what happens when engineering meets a market, shipping AI systems for clients, and now building at a startup from the inside. The progression matters more to me than any single title.

**What I believe.** Being a 10x developer doesn't mean you ship 10x more; it means you deliver 10x more value. The ROI on you is 10x. That's the bar I measure myself against: value delivered, not output produced.

**How I work.** Founder mindset: hustle is the only pillar of success you fully control. I have OCD, and I've made it work for me: everything I do is extremely organized: my code, my notes, my calendar, my agents. My dev loop runs on orchestrated AI: multiple [Claude Code](https://www.anthropic.com/claude-code) agents in parallel via [Conductor](https://conductor.build), with persistent memory and Slack wiring. [Screenpipe](https://screenpipe.com) is my second brain for everything I do in a day; [Amie](https://amie.so) holds every meeting note.

Off the clock: recently married, and training for my first marathon this October. 🏃
`,
  avatar: 'https://www.victorsaisse.com/images/victor-saisse.png',
  ogImage: 'https://www.victorsaisse.com/images/og-image.png',
  namePronunciationUrl: undefined,
  timeZone: 'America/Toronto',
  keywords: [
    'victorsaisse',
    'victor saisse',
    'founding engineer',
    'ai software engineer',
    'full stack developer',
    'react native',
    'cloudflare workers',
    'software engineer',
    'montreal developer',
    'la viral studio',
    'easyframe',
  ],
  dateCreated: '2026-01-05', // YYYY-MM-DD
  // Used to answer age questions in the AI chat. YYYY-MM-DD, or undefined to
  // withhold. Age is computed at request time so it never goes stale.
  dateOfBirth: '1998-09-15',
} satisfies User;
